import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DependencyConstraintInfo  {
    _originalTypeClassName = "zERP.BO.DependencyConstraintInfo";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DependencyConstraintInfo.translate = translateService;
}
this.Children = [];
this.ClassName = null;
this.Id = null;
this.Display = null;
this.CannotBeDeleted = false;
this.DependencyConstraintInfoKey = null;
this._key = this.DependencyConstraintInfoKey = 0; 
}

static translate: TranslateService;
_key: any;
ClassName:any;
Id:any;
Display:any;
CannotBeDeleted:any;
Children:any;
private _DependencyConstraintInfoKey:any;
get DependencyConstraintInfoKey(): any {
    return this._DependencyConstraintInfoKey;
  }
set DependencyConstraintInfoKey(value: any) {
    this._DependencyConstraintInfoKey = value;
    this._key = value;
  }
static setChildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.Children == null) $this.Children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Children.length > 0) {
                    Domain.DependencyConstraintInfo.removeChildren($this, $this.Children[0]);
                }

                Domain.DependencyConstraintInfo.addManyChildren($this, copyItems);
            }
static addManyChildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.DependencyConstraintInfo.addChildren($this, items[i]);
                }
            }
static addChildren = ($this, item) => {
                if ($this.Children == null) $this.Children = [];
                if (item == null || $this.Children.indexOf(item) > -1) return;
                $this.Children.push(item);
}
static addRangeChildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.DependencyConstraintInfo.addChildren($this, item));
            }
static removeChildren = ($this, item) => {
                if ($this == null || $this.Children == null || $this.Children.indexOf(item) === -1) return;
                var _index = $this.Children.indexOf(item);
                $this.Children.splice(_index, 1);
}
static clearChildren = ($this) => { $this.Children = null; }

static ToTreeNode($this: any): any{let treeNode = new Domain.DependencyConstraintInfoTreeListNode();
treeNode.info = $this?.Id?.toString();
treeNode.key = $this?.Id;
treeNode.label = $this?.Display;
treeNode.expanded = true;
Domain.DependencyConstraintInfoTreeListNode.setdata(treeNode, $this);
Domain.DependencyConstraintInfoTreeListNode.setchildren(treeNode, Joove.Common.cast($this?.Children?.linq?.select((c) => Domain.DependencyConstraintInfo.ToTreeNode(c))?.toArray(), "System.Collections.List"));
return treeNode;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.DependencyConstraintInfoKey == null || $this.DependencyConstraintInfoKey == 0;
            }


}